import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useOutletContext } from "react-router-dom";
import ImageInput from "../../../components/WriteProject/ImageInput/ImageInput";
import WpInput from "../../../components/WriteProject/WpInput/WpInput";
import WpTitle from "../../../components/WriteProject/WpTitle/WpTitle";
import { ProjectType } from "../../../interface/interface";
import { PopupChange } from "../../../reducers/config";

function Step1() {
  const patch = useDispatch();
  const {
    state: {
      category,
      mainimg,
      price,
      period: { start, finish },
      leader,
      title,
      // field: { rough },
      finish_time,
    },
    dispatch,
    isError,
    UpdateCommon,
  }: {
    state: ProjectType;
    dispatch: (p: object) => void;
    isError: boolean;
    UpdateCommon: (type: string, payload: string | number) => void;
  } = useOutletContext();

  const __searchLeader = useCallback(() => {
    patch(
      PopupChange({
        active: true,
        type: "leader",
        content: "writeProject",
      })
    );
  }, [patch]);
  return (
    <div className="step1">
      <WpTitle title="기본 정보" />
      <div className="basic-info">
        <div className="left">
          <WpInput
            title="프로젝트명"
            placeholder="프로젝트 명을 입력해주세요"
            initial={title}
            max={29}
            type="text"
            reg={"title"}
            __update={UpdateCommon}
            error={
              isError && title.length < 1
                ? "프로젝트 명을 입력해주세요"
                : undefined
            }
          />
          <div className="category-wrapper">
            <div className="title">
              카테고리 <span>택1</span>
            </div>
            <div className="btn-wrapper">
              {categoryArr.map(({ title, type }, idx) => {
                return (
                  <button
                    key={idx}
                    className={category === type ? "active-category" : ""}
                    onClick={() => {
                      UpdateCommon("category", type);
                    }}
                  >
                    {title}
                  </button>
                );
              })}
            </div>
          </div>
          <div className="period-wrapper">
            <div className="start">
              <WpInput
                title="모집 시작일"
                initial={start}
                placeholder="YYYY-MM-DD"
                max={undefined}
                type="text"
                reg={"start"}
                __update={UpdateCommon}
                error={
                  isError
                    ? isNaN(new Date(start).getTime())
                      ? "유효한 날짜를 입력해주세요"
                      : undefined
                    : undefined
                }
              />
            </div>
            <div className="line">~</div>
            <div className="finish">
              <WpInput
                title="모집 마감일"
                initial={finish}
                placeholder="YYYY-MM-DD"
                max={undefined}
                type="text"
                reg={"finish"}
                __update={UpdateCommon}
                error={
                  isError
                    ? isNaN(new Date(finish).getTime())
                      ? "유효한 날짜를 입력해주세요"
                      : new Date(finish).getTime() <= new Date(start).getTime()
                      ? "시작일 이후의 날짜를 입력해주세요"
                      : undefined
                    : undefined
                }
              />
            </div>
          </div>
          {/* <div className="field-wrapper">
            <WpInput
              title="모집 분야"
              initial={rough}
              placeholder="예) 개발자 + 디자이너 + 기획자"
              max={29}
              type="text"
              reg={"rough"}
              __update={UpdateCommon}
              error={
                isError && rough.length < 1
                  ? "모집 분야를 입력해주세요"
                  : undefined
              }
            />
          </div> */}
          <div className="finish-time-wrapper">
            <WpInput
              title="프로젝트 시작일"
              placeholder="YYYY-MM-DD"
              initial={finish_time}
              max={undefined}
              type="text"
              reg={"finish_time"}
              __update={UpdateCommon}
              error={
                isError
                  ? isNaN(new Date(finish_time).getTime())
                    ? "유효한 날짜를 입력해주세요"
                    : undefined
                  : undefined
              }
            />
          </div>
          <div className="leader-wrapper">
            <div className={`select-wrapper`}>
              <div className="title">팀 리더명</div>
              <div
                className={`leader-select ${leader.id ? "choice-leader" : ""}`}
                onClick={__searchLeader}
              >
                <div className="title">
                  {leader.id
                    ? leader.name
                      ? leader.name
                      : "선택 완료"
                    : "팀 리더 선택"}
                </div>
                <img src="/assets/project/right-arrow.svg" alt="" />
              </div>
            </div>
            <WpInput
              title="팀 리더 추가설명"
              initial={leader.sub}
              placeholder="예 ) 현 삼성카드 데이터 분석팀 팀장"
              max={40}
              type="text"
              reg={"leader/sub"}
              __update={UpdateCommon}
              error={
                isError && leader.sub.length < 1
                  ? "설명을 입력해주세요"
                  : undefined
              }
            />
          </div>
          <div className="price-wrapper">
            <WpInput
              title="참가비"
              initial={price}
              placeholder="숫자를 입력해주세요"
              max={undefined}
              type="text"
              reg={"price"}
              __update={UpdateCommon}
              error={
                isError && price.length < 1
                  ? "참가비를 입력해주세요"
                  : undefined
              }
            />
          </div>
        </div>
        <div className="right">
          <ImageInput
            title="썸네일 이미지"
            sub="jpg / png 확장자 / 564x475px 권장"
            data={mainimg}
            __update={UpdateCommon}
            isError={isError}
            type="mainimg"
          />
        </div>
      </div>
    </div>
  );
}

export default Step1;

const categoryArr = [
  { title: "IT / SW / 개발", type: "dev" },
  { title: "비영리 / 캠페인", type: "cmpgn" },
  { title: "언론 / 미디어", type: "md" },
  { title: "마케팅", type: "mrk" },
  { title: "문화예술", type: "art" },
  { title: "물류 / 제조", type: "lgs" },
  { title: "서비스", type: "svc" },
  { title: "디자인", type: "dsgn" },
  { title: "영상 / 콘텐츠", type: "vid" },
  { title: "사회공헌 / ESG", type: "esg" },
  { title: "창업 / 스타트업", type: "strtp" },
  { title: "데이터 / AI", type: "dta" },
];
